import React, { useContext, useEffect, useRef, useState } from 'react'
import { formatDate } from '@fullcalendar/core'
import FullCalendar from '@fullcalendar/react'
import dayGridPlugin from '@fullcalendar/daygrid'
import timeGridPlugin from '@fullcalendar/timegrid'
import interactionPlugin from '@fullcalendar/interaction'
import { INITIAL_EVENTS, createEventId } from './event-utils'
import jwtInterceoptor from '../../components/shared/jwtInterceptor'
import { useTranslation } from "react-i18next";
import {toast, ToastContainer} from "react-toastify";

import Button from '@mui/material/Button';
import { styled } from '@mui/material/styles';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import IconButton from '@mui/material/IconButton';

import Swal from 'sweetalert2';
import OrgContext from '../../organisation/OrgContext'
import { useNavigate } from 'react-router-dom'

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  '& .MuiDialogContent-root': {
  padding: theme.spacing(2),
  },
  '& .MuiDialogActions-root': {
  padding: theme.spacing(1),
  },
}));
function BootstrapDialogTitle(props) {
  const { children, onClose, ...other } = props;

  return (
  <DialogTitle sx={{ m: 0, p: 2 }} {...other}>
      {children}
      {onClose ? (
      <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{
          position: 'absolute',
          right: 8,
          top: 8,
          color: (theme) => theme.palette.grey[500],
          }}
      >
          x
      </IconButton>
      ) : null}
  </DialogTitle>
  );
}  

const Calendar = () => {

  const [t, i18n] = useTranslation();

  const {organisation} = useContext(OrgContext);

  const [weekendsVisible, setWeekendsVisible] = useState(true);
  const [currentEvents, setCurrentEvents] = useState([]);
  const [infoCalendar, setInfosCalendar] = useState(null);

  const [invoiceData, setInvoiceData] = useState(null);

  const navigate = useNavigate();

  const [dueInvoices, setDueInvoices] = useState({});

  const [open, setOpen] = React.useState(false);

  const title_ref = useRef("");
  const url_ref = useRef("");
  const content_ref = useRef("");
  const allDay_ref = useRef("");

  useEffect(()=> {
    const fetchEvents = async () => {
      const eventsResponse = await jwtInterceoptor.get("/data/events/all");

      if(eventsResponse.statusText === "OK"){
        setCurrentEvents(eventsResponse.data.data);
      }
    }

    fetchEvents();
    if (organisation.id) {
      fetchDueInvoice();
    }
    
  }, []);

  const fetchDueInvoice = async () => {
    const response = await jwtInterceoptor.get(`/data/dueInvoice/events/${organisation.id}`);

    if(response.status === 200){
      //setCurrentEvents([...currentEvents, response.data.data]);
      setCurrentEvents(current => [...current, ...response.data.data]);
      console.log(currentEvents);
    }

    
  }

  const handleWeekendsToggle = () => {

    setWeekendsVisible(!weekendsVisible);
  }

  const handleDateSelect = (selectInfo) => {
    let calendarApi = selectInfo.view.calendar

    setInfosCalendar(selectInfo);
  
    setOpen(true);

    calendarApi.unselect(); 
  }

  const saveEvent = async () => {
    if(infoCalendar){
      if(
          title_ref.current.value.trim().length > 0 
          && allDay_ref.current.value.trim().length > 0
      ){
          try {

              let formData = new FormData();

              formData.append("title", title_ref.current.value);
              formData.append("content", content_ref.current.value);
              formData.append("allDay", allDay_ref.current.value);
              formData.append("url", url_ref.current.value);
              formData.append("start", infoCalendar.startStr);
              formData.append("end", infoCalendar.endStr);
      
              const response = await jwtInterceoptor.post(
                  "/data/events/save",
                  formData, 
                  {
                      headers: {
                          'Content-Type': 'application/json'
                      }
                  }
              );

              if(response.status == 200){
                  if(response.data.status == true){
                      handleClose();
                      Swal.fire({
                          icon: 'success',
                          text: t(response.data.message),
                      });

                      setCurrentEvents(current => [...current, response.data.data]);
                      
                  }else{
                      Swal.fire({
                          icon: 'warning',
                          title: 'Oops...',
                          text: t(response.data.message),
                      });
                  }
              }else{
                  Swal.fire({
                      icon: 'warning',
                      title: 'Oops...',
                      text: t('Something went wrong!, try again'),
                  });
              }

              setInfosCalendar(null);
              
          } catch (error) {
              console.error(error);
              Swal.fire({
                  icon: 'warning',
                  title: 'Oops...',
                  text: t('Something went wrong!, try again'),
              });
          }
      }else{
          Swal.fire({
              icon: 'warning',
              title: 'Oops...',
              text: t('Fill all fields'),
          });
      }
    }
  }

  const handleClickOpen = () => {
      setOpen(true);
  };
  const handleClose = () => {
      setOpen(false);
  };


  const handleEventClick = (event) => {
    event.jsEvent.preventDefault();
    let data = event.event;
    let extraData = data?.extendedProps;
    if(extraData?.isInvoice){
      setInvoiceData(extraData);
      window.$('#staticBackdrop').modal('show');
    }else{
      Swal.fire({
        title: `<strong>${data?.title}</strong>`,
        icon: 'info',
        html:
        ` 
          <ul>
            <li>Date debut : ${data?.start}</li>
            <li>Date fin : ${data?.end}</li>
            <li>${data?.extendedProps?.content}</li>
            <li>url : ${data?.url != "null" ? '<a href="'+data?.url+'" target="_blank">'+data?.url+'</a>' : '-'}</li>
          </ul>
        `,
        showCloseButton: true,
        showCancelButton: true,
        focusConfirm: false,
        cancelButtonText: t("Cancel"),
        confirmButtonText:
          'Supprimer',
        
      }).then(async (result) => {
          if (result.isConfirmed) {
              const response = await jwtInterceoptor.delete(`/data/events/delete/${data?.id}`);
  
              if(response.status === 200){
                  if(response.data.status == true){
                      let events = currentEvents.filter(el => el.id != data?.id);
  
                      setCurrentEvents(events);
  
  
                      Swal.fire(
                          t('Deleted!'),
                          t('Your record has been deleted.'),
                          'success'
                      )
  
                      return;
                  }
                  
              }
  
              Swal.fire({
                  icon: 'warning',
                  title: 'Oops...',
                  text: t('Something went wrong!, try again'),
              });
              
          }
      })
    }
  }

  const handleEvents = (events) => {
    setCurrentEvents(events)
  }

    const seeInvoice = (info) => {
        /**
         * {
         *     "due_date": "2023-10-07",
         *     "month": 10,
         *     "invoice_id": 47,
         *     "invoice_title": "Date d'echance pour la facture d'avoir N° 000047",
         *     "content": "",
         *     "isInvoice": true,
         *     "invoice_type": "facture",
         *     "text_color": "#d20404"
         * }*/
        if (info?.invoice_type == "achat") {
          window.$('#staticBackdrop').modal('hide');
          navigate(`/invoice/achat/details/${info.invoice_id}`, { replace: true });
      } else if (info?.invoice_type == "depense") {
          window.$('#staticBackdrop').modal('hide');
          navigate(`/invoice/depense/details/${info.invoice_id}`, { replace: true });
      } else {
          window.$('#staticBackdrop').modal('hide');
          navigate(`/invoice/details/${info.invoice_id}`, { replace: true });
      }
      
    }

    const envoyerRappel = async (info) => {
        window.$('#staticBackdrop').modal('hide');
        const id = toast.loading(
            "Votre email est en cours d'envoi, veuillez ne pas fermer la fenêtre.", {
                position: "top-center",
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "dark",
            });

        const response = await jwtInterceoptor.post('data/user/rappel/send', info).then(res => {
            toast.update(id, { render: "Votre email a été envoyé avec succès.", type: "success", isLoading: false });
        }).catch((error) => console.log(error));
    }

  return (
    <>
        <ToastContainer/>
    <div className="card">
      <div className="card-header">
          <h3 className="card-title">{"Calendrier"}</h3>
      </div>
      <div className="card-body">
        <div class="modal fade" id="staticBackdrop" data-bs-backdrop="static" data-bs-keyboard="false"
            tabIndex="-1" aria-labelledby="staticBackdropLabel" aria-hidden="true">
            <div class="modal-dialog">
                <div class="modal-content">
                    <div class="modal-header">
                        <h1 class="modal-title fs-5" id="staticBackdropLabel">{invoiceData? invoiceData.invoice_title: ""}</h1>
                        <button type="button" className="btn-close" data-bs-dismiss="modal"
                                aria-label="Close"></button>
                    </div>
                    <div class="modal-body">
                        {invoiceData ? (
                          <>
                            <p style={{fontSize: 18, color: invoiceData.text_color}}>Date d'échéance: {invoiceData.due_date} </p>
                            <div style={{
                              display: "flex",
                              flex: 1,
                              flexDirection: "row",
                              justifyContent: "space-between",
                              alignItems: "self-end"
                            }}>
                              <button id="bVoir" type="button" className="btn  btn-sm btn-primary">
                                  <div onClick={()=>seeInvoice(invoiceData)}><span
                                      className="fe fe-eye"> </span><span>Voir</span></div>
                              </button>
                              <button onClick={()=>envoyerRappel(invoiceData)} id="bMail" type="button" className="btn  btn-sm btn-warning">
                                  <span className="fe fe-mail"> </span><span>Rappel</span>
                              </button>
                            </div>
                            
                          </>
                        ):null}
                    </div>
                    <div class="modal-footer">
                        <button type="button" className="btn btn-secondary" onClick={() => {
                            setInvoiceData(null);
                            window.$('#staticBackdrop').modal('hide');
                        }
                        }>Fermer
                        </button>
                    </div>
                </div>
            </div>
        </div>
        <div className='demo-app'>
          <div className='demo-app-main'>
            <FullCalendar
              plugins={[dayGridPlugin, timeGridPlugin, interactionPlugin]}
              headerToolbar={{
                left: 'prev,next today',
                center: 'title',
                right: 'dayGridMonth,timeGridWeek,timeGridDay'
              }}
              initialView='timeGridWeek'
              events={currentEvents}
              editable={true}
              selectable={true}
              selectMirror={true}
              dayMaxEvents={true}
              weekends={weekendsVisible}
              
              select={handleDateSelect}
              eventContent={renderEventContent} 
              eventClick={handleEventClick}
              
            />
          </div>
        </div>
      </div>
    </div>
    <BootstrapDialog
        onClose={handleClose}
        aria-labelledby="customized-dialog-title"
        open={open}

        style={{ zIndex: 2}}
    >
        <BootstrapDialogTitle id="customized-dialog-title" onClose={handleClose}>
            {t("Ajouter un evenement")}
        </BootstrapDialogTitle>
        <DialogContent dividers>
            <div className="form-group">
                <label className="form-label">{t("Titre")} <span className="text-red">*</span></label>
                <input ref={title_ref} type="text" className="form-control"  />
            </div>
            <div className="form-group">
                <label className="form-label">{t("Event toute la journée")} <span className="text-red">*</span></label>
                <select ref={allDay_ref} className="form-control form-select"  >
                    <option value={0}>Non</option>
                    <option value={1}>Oui</option>
                </select>
            </div>
            <div className="form-group">
                <label className="form-label">{t("Url")}</label>
                <input ref={url_ref} type="url" className="form-control"  />
            </div>
            <div className="form-group">
                <label className="form-label">{t("contenu")}</label>
                <textarea ref={content_ref} className="form-control"></textarea>
            </div>
        </DialogContent>
        <DialogActions>
            <Button onClick={handleClose}>
                {t("Cancel")}
            </Button>
            <Button autoFocus onClick={saveEvent}>
                {t("Sauvegarder les modifications")}
            </Button>
        </DialogActions>
        </BootstrapDialog>
    </>
  );
};

export default Calendar;

// export default class Calendar extends React.Component {

//   state = {
//     weekendsVisible: true,
//     currentEvents: [
//       { title: 'event 1', date: '2023-05-01' },
//       { title: 'event 2', date: '2023-05-02' }
//     ]
//   }

//   render() {
//     return (
//       <div className="card">
//         <div className="card-header">
//             <h3 className="card-title">{"Calendrier"}</h3>
//         </div>
//         <div className="card-body">
//           <div className='demo-app'>
//             <div className='demo-app-main'>
//               <FullCalendar
//                 plugins={[dayGridPlugin, timeGridPlugin, interactionPlugin]}
//                 headerToolbar={{
//                   left: 'prev,next today',
//                   center: 'title',
//                   right: 'dayGridMonth,timeGridWeek,timeGridDay'
//                 }}
//                 initialView='dayGridMonth'
//                 events={[
//                   { title: 'event 1', date: '2023-05-12' },
//                   { title: 'event 2', date: '2023-05-14' }
//                 ]}
//                 editable={true}
//                 selectable={true}
//                 selectMirror={true}
//                 dayMaxEvents={true}
//                 weekends={this.state.weekendsVisible}
//                 initialEvents={INITIAL_EVENTS} // alternatively, use the `events` setting to fetch from a feed
//                 select={this.handleDateSelect}
//                 eventContent={renderEventContent} // custom render function
//                 eventClick={this.handleEventClick}
//                 // eventsSet={this.handleEvents} // called after events are initialized/added/changed/removed
//                 /* you can update a remote database when these fire:
//                 eventAdd={function(){}}
//                 eventChange={function(){}}
//                 eventRemove={function(){}}
//                 */
//               />
//             </div>
//           </div>
//         </div>
//       </div>
//     )
//   }

  

//   handleWeekendsToggle = () => {
//     this.setState({
//       weekendsVisible: !this.state.weekendsVisible
//     })
//   }

//   handleDateSelect = (selectInfo) => {
//     let title = prompt('Please enter a new title for your event')
//     let calendarApi = selectInfo.view.calendar

//     calendarApi.unselect() // clear date selection

//     if (title) {
//       calendarApi.addEvent({
//         id: createEventId(),
//         title,
//         start: selectInfo.startStr,
//         end: selectInfo.endStr,
//         allDay: selectInfo.allDay,
//         content: "note test"
//       })
//     }
//   }

//   handleEventClick = (clickInfo) => {
//     console.log(clickInfo.event);
//     // if (confirm(`Are you sure you want to delete the event '${clickInfo.event.title}'`)) {
//     //   clickInfo.event.remove()
//     // }
//   }

//   handleEvents = (events) => {
//     this.setState({
//       currentEvents: events
//     })
//   }

// }

function renderEventContent(eventInfo) {
  return (
    <>
      <b>{eventInfo.timeText}</b>
      <i>{eventInfo.event.title}</i>
    </>
  )
}
